module.exports = __webpack_public_path__ + "img/subject_banner4.460842da.png";